module.exports = __webpack_public_path__ + "img/HZ-A1008.f3266583.jpg";